import { FormControl, Input, Text } from '@chakra-ui/react'
import React, { Dispatch, SetStateAction } from 'react'
import InputMask from "react-input-mask";

interface Props {
    field: FormField
    data: any,
    setData: Dispatch<SetStateAction<FormData[]>>
}

interface FormField {
    key: string,
    label: string
}

interface FormData {
    key: string,
    value: string
}

const fieldsWithMaks = [
    'cpf',
    'birthdate',
    'phone'
]

const fieldMask = [
    {
        key: 'cpf',
        mask: '999.999.999-99',
    },
    {
        key: 'birthdate',
        mask: '99/99/9999',
    },
    {
        key: 'phone',
        mask: '(99) 999999999',
    }
]

const FormField = ({ field, data, setData }: Props) => {
    const fieldName = field.key

    const onChange = (value: string) => {
        const currentData = data;
        currentData[field.key] = value;

        setData({ ...data });
    }

    const hasMask = (key: string) => fieldsWithMaks.includes(key)

    return (
        <FormControl>
            <Text mb={2} fontWeight="bold" fontSize="md">{field.label}</Text>
            {
                hasMask(field.key) ?
                    <Input
                        name={field.key}
                        value={data[field.key]}
                        onChange={({ target }) => onChange(target.value)}
                        as={InputMask}
                        mask={fieldMask.find(mask => mask.key == field.key)?.mask || ""}
                        borderRadius="8px"
                        fontSize="md"
                    />
                    :
                    <Input
                        name={field.key}
                        value={data[field.key]}
                        onChange={({ target }) => onChange(target.value)}
                        borderRadius="8px"
                        fontSize="md"
                    />
            }
        </FormControl>
    )
}

export default FormField